// A card with a title and, on the right, its buttons.
import type { ReactNode } from 'react'

interface SectionProps {
  title: ReactNode
  actions?: ReactNode
  children: ReactNode
  testId?: string
}

export function Section({ title, actions, children, testId }: SectionProps) {
  return (
    <section className="card mb-4 min-w-0" data-testid={testId}>
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h2 className="section-title mb-0">{title}</h2>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
      {children}
    </section>
  )
}
